function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import './geo_coordinate.scss';
import CustomHTMLElement from 'html-element';

var GeoCoordinateCurrent = /*#__PURE__*/function (_CustomHTMLElement) {
  _inherits(GeoCoordinateCurrent, _CustomHTMLElement);

  var _super = _createSuper(GeoCoordinateCurrent);

  function GeoCoordinateCurrent() {
    _classCallCheck(this, GeoCoordinateCurrent);

    return _super.apply(this, arguments);
  }

  _createClass(GeoCoordinateCurrent, [{
    key: "_runSetup",
    value: function _runSetup() {
      _get(_getPrototypeOf(GeoCoordinateCurrent.prototype), "_runSetup", this).call(this);

      this.loadingText = this.getAttribute('data-loading-text') || 'Locating...';
      this.errorText = this.getAttribute('data-error-text') || 'Unable to detect current location';
      this.statusField = this.querySelector('[name$=_status]') || this.querySelector('[name$="_status]"]');
      this.latitudeField = this.querySelector('[name$=_latitude]') || this.querySelector('[name$="_latitude]"]');
      this.longitudeField = this.querySelector('[name$=_longitude]') || this.querySelector('[name$="_longitude]"]');
      this.accuracyField = this.querySelector('[name$=_accuracy]') || this.querySelector('[name$="_accuracy]"]');
      this.textElement = this.querySelector('span');

      if (this.latitudeField.length > 0 && this.longitudeField.length > 0) {
        this.showCurrentLocation();
        this.hasUpdatedLocation = true;
      }
    }
  }, {
    key: "hasLocationServices",
    get: function get() {
      return !!navigator.geolocation;
    }
  }, {
    key: "updateCurrentLocation",
    value: function updateCurrentLocation() {
      var _this = this;

      this.showLoadingMessage();
      return new Promise(function (resolve, reject) {
        if (!_this.hasLocationServices) {
          _this.statusField.value = 'unsupported';
          _this.hasUpdatedLocation = true;

          _this.showErrorMessage();

          reject();
          return;
        }

        var options = {
          enableHighAccuracy: true,
          maximumAge: 0
        };
        navigator.geolocation.getCurrentPosition(function (position) {
          _this.hasUpdatedLocation = true;
          _this.latitudeField.value = position.coords.latitude;
          _this.longitudeField.value = position.coords.longitude;

          if (_this.accuracyField) {
            _this.accuracyField.value = position.coords.accuracy;
          }

          _this.showCurrentLocation();

          resolve();
        }, function (error) {
          if (error.code === GeolocationPositionError.PERMISSION_DENIED) {
            _this.statusField.value = 'denied';
          } else {
            _this.statusField.value = 'failed';
          }

          _this.hasUpdatedLocation = true;

          _this.showErrorMessage();

          reject();
        }, options);
      });
    }
  }, {
    key: "showLoadingMessage",
    value: function showLoadingMessage() {
      this.textElement.classList.add('geocoordinate-current__placeholder');
      this.textElement.innerText = this.loadingText;
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage() {
      this.textElement.classList.remove('geocoordinate-current__placeholder');
      this.textElement.innerText = this.errorText;
    }
  }, {
    key: "showCurrentLocation",
    value: function showCurrentLocation() {
      this.textElement.classList.remove('geocoordinate-current__placeholder');
      this.textElement.innerText = "".concat(this.latitudeField.value, ", ").concat(this.longitudeField.value);
    }
  }]);

  return GeoCoordinateCurrent;
}(CustomHTMLElement);

window.customElements.define('geocoordinate-current', GeoCoordinateCurrent);